import * as React from 'react';
import { FacebookShareButton } from 'react-share';
import styled from 'styled-components';

import { flexGap, horizontalSpaceLineDivider } from '@doltech/utils/lib/css-style';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';
import { IconSystemV2CourseInfoOutline } from '@doltech/icons/SystemV2/IconSystemV2CourseInfoOutline';
import { IconSystemV2EssentialListRableOfContentToc } from '@doltech/icons/SystemV2/IconSystemV2EssentialListRableOfContentToc';
import { IconSystemV2ArrowToTop } from '@doltech/icons/SystemV2/IconSystemV2ArrowToTop';
import { IconSystemV2LogoFacebook2 } from '@doltech/icons/SystemV2/IconSystemV2LogoFacebook2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { ButtonIconPrimaryGeneral } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';

const FacebookShare = styled.div`
  display: flex;
  align-items: center;

  padding: 8px 0 8px 12px;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(6)}
`;

const Container = styled.div`
  display: flex;
  align-items: center;

  padding: 4px;
  background-color: ${colorsV2.white100};
  border: 1px solid ${colorsV2.neutral20};
  border-radius: 40px;
  box-shadow: ${shadows.neutralShadowToBot4};

  ${horizontalSpaceLineDivider({
    space: 6,
    lineSize: 1,
    lineColor: colorsV2.neutral20,
  })}
`;

interface LandingBlogButtonReadingTableOfContentProps {
  pageUrl?: string;

  onClickInfo?: () => void;
  onClickToc?: () => void;
  onClickToTop?: () => void;

  infoActive?: boolean;
  tocActive?: boolean;
  canViewToc?: boolean;
}

export const LandingBlogButtonReadingTableOfContent = (props: LandingBlogButtonReadingTableOfContentProps) => {
  const { pageUrl, onClickInfo, onClickToc, onClickToTop, infoActive = false, tocActive = false, canViewToc = false } = props;

  return (
    <Container className="blog-button-bottom-action">
      <FacebookShareButton key="facebook-share" url={pageUrl}>
        <FacebookShare>
          <ResponsiveTypography.Paragraph variant="medium/14-20" color="neutral120" mr="4px">
            Share
          </ResponsiveTypography.Paragraph>
          <IconSystemV2LogoFacebook2 size={24} color="neutral160" />
        </FacebookShare>
      </FacebookShareButton>
      <ButtonGroup>
        <ButtonIconPrimaryGeneral
          type="black"
          size="x-large"
          shape="circle"
          icon={
            infoActive
              ? <IconSystemV2EssentialClose />
              : <IconSystemV2CourseInfoOutline />
          }
          onClick={onClickInfo}
          active={infoActive}
          transparent
        />
        <ButtonIconPrimaryGeneral
          type="black"
          size="x-large"
          shape="circle"
          icon={
            tocActive
              ? <IconSystemV2EssentialClose />
              : <IconSystemV2EssentialListRableOfContentToc />
          }
          onClick={onClickToc}
          active={tocActive}
          disabled={!canViewToc}
          transparent
        />
      </ButtonGroup>
      <ButtonIconPrimaryGeneral
        type="white"
        size="x-large"
        shape="circle"
        icon={<IconSystemV2ArrowToTop />}
        onClick={onClickToTop}
        transparent
      />
    </Container>
  );
};
